<template>
    <div>
        <div class="vx-row ml-1 mt-3">
            <div class="vx-row mb-6" style="width:70%">
                <div class="vx-col sm:w-1/4 w-full flex items-center">
                    <span>Warehouse Code</span>
                </div>
                <div class="vx-col sm:w-3/4 w-full">
                    <CustomSelect :value="selectedSrcWarehouses" base-url="/api/wms/v1/master/warehouses" 
                        label="name" 
                        track-by="name" 
                        :multiple="true" 
                        :allowEmpty="false"
                        :placeholder="'type to search, min 3 characters'"
                        @selected="(val) => {
                            this.selectedSrcWarehouses = val;
                        }">
                    </CustomSelect>
                </div>
            </div>
            <div class="vx-row mb-6" style="width:70%">
                <div class="vx-col sm:w-1/4 w-full flex items-center">
                    <span>Transaction Type</span>
                </div>
                <div class="vx-col sm:w-3/4 w-full">
                    <CustomSelect :value="selectedTrxType" :options="trxTypeOptions" 
                        label="name" 
                        track-by="code" 
                        :multiple="true" 
                        :allowEmpty="false"
                        @selected="(val) => {
                            this.selectedTrxType = val;
                        }">
                    </CustomSelect>
                </div>
            </div>
            <div class="vx-row mb-6" style="width:70%">
                <div class="vx-col sm:w-1/4 w-full flex items-center">
                    <span>GR Status</span>
                </div>
                <div class="vx-col sm:w-3/4 w-full">
                    <CustomSelect :value="selectedGrStatus" :options="grStatusOptions" 
                        label="name" 
                        track-by="code" 
                        :multiple="true" 
                        :allowEmpty="false"
                        @selected="(val) => {
                            this.selectedGrStatus = val;
                        }">
                    </CustomSelect>
                </div>
            </div>
            <!-- tambahkan gr date range, default today -->
            <div class="vx-row mb-6" style="width:70%">
                <div class="vx-col sm:w-1/4 w-full flex items-center">
                    <span>GR Date Range</span>
                </div>
                <div class="vx-col sm:w-3/4 w-full">
                    <DateRangePicker @selected="selectedGrDateRange = $event" />
                </div>
            </div>
            <div class="vx-row mb-6" style="width:70%">
                <div class="vx-col sm:w-1/4 w-full flex items-center">
                </div>
                <div class="vx-col sm:w-3/4 w-full">
                    <vs-button color="primary" @click="handleFilter()">Filter</vs-button>
                </div>
            </div>
        </div>
        <Table
            :draw="draw"
            :whIDs="selectedWarehouseIDs"
            :trxType="selectedTrxTypeString"
            :grStatus="selectedGrStatusString"
            :grDateRange="selectedGrDateRange">
        </Table>
    </div>
</template>
<script>
import CustomSelect from "./component/CustomSelect.vue";
import DateRangePicker from "@/components/DateRangePicker.vue";
import Table from "./component/table.vue";
import moment from "moment";
import vSelect from "vue-select";
export default {
    components: {
        CustomSelect,
        DateRangePicker,
        Table,
        vSelect
    },
    mounted() {
        let wh = {
            id: 0,
            code: "All",
            name: "All"
        }

        if (this.selectedSrcWarehouses.length == 0) {
            this.selectedSrcWarehouses = [wh]
        }
    },
    data() {
        return {
            activeTab: "Data",
            draw: 0,
            selectedSrcWarehouses: [],
            selectedWarehouseIDs: "0",
            trxTypeOptions: [
                { id: 0, code: 'All', name: 'All' },
                { id: 1, code: 'Inbound PO', name: 'Inbound PO' },
                { id: 2, code: 'Inbound Customer Return', name: 'Inbound Customer Return' }
            ],
            selectedTrxType: [{ id: 0, code: 'All', name: 'All' }],
            selectedTrxTypeString: 'All',
            grStatusOptions: [
                { id: 0, code: 'All', name: 'All' },
                { id: 1, code: 'Waiting Approval', name: 'Waiting Approval' },
                { id: 2, code: 'Complete with Approval', name: 'Complete with Approval' },
                // { id: 2, code: 'Complete', name: 'Complete' },
                { id: 3, code: 'Rejected', name: 'Rejected' }
            ],
            selectedGrStatus: [{ id: 0, code: 'All', name: 'All' }],
            selectedGrStatusString: 'All',
            selectedGrDateRange: {
                startDate: new Date(),
                endDate: new Date()
            }
        }
    },
    methods: {
        handleFilter() {
            this.draw += 1;
            console.log('handleFilter', this.selectedGrDateRange);
        },
    },
    watch: {
        selectedSrcWarehouses() {
            this.selectedWarehouseIDs = this.selectedSrcWarehouses.map(item => item.id).join(",")
        },
        selectedTrxType() {
            this.selectedTrxTypeString = this.selectedTrxType.map(item => item.code).join(',') || 'All';
        },
        selectedGrStatus() {
            this.selectedGrStatusString = this.selectedGrStatus.map(item => item.code).join(',') || 'All';
        }
    }
}
</script>
